import api from '@/plugins/api';

export default class CoreAccount {
  constructor(parent) {
    this.$parent = parent;
    this.model = {
      agency: '',
      login: '',
      password: '',
      repassword: '',
      newpassword: '',
      email: '',
      office: null,
    };

    this.partner = null;
    this.legal = null;
    this.user = null;
    this.region = null;
    this.office = null;
    this.authentication = null;
    this.tariff = null;

    this.isAuthentication = false;
    this.isAgency = false;
    this.isErc = false;
    this.isSub = false;

    this.loading = false;
  }

  get core() {
    return this.$parent;
  }

  init() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      self.password = '';
      self.repassword = '';
      self.newpassword = '';
      self.email = '';
      self.office = null;
      api.account
        .current()
        .then((data) => {
          self.set(data);
          resolve();
        }, (error) => {
          self.set();
          reject(error);
        })
        .finally(() => {
          self.loading = false;
        });
    });
  }

  set(data = {}) {
    this.isAuthentication = data.isAuthentication || false;
    if (this.isAuthentication) {
      this.model.agency = data.agency;
      this.model.login = data.login;
      this.user = data.user;
      this.core.storage.set({
        agency: data.agency,
        login: data.login,
        user: data.user,
      });
    } else {
      const storage = this.core.storage.get();
      this.model.agency = storage.agency || '';
      this.model.login = storage.login || '';
      this.user = storage.user || null;
    }
    this.partner = data.partner || null;
    this.legal = data.legal || null;
    this.region = data.region || null;
    this.office = data.office || null;
    this.authentication = data.authentication || null;
    this.tariff = data.tariff || null;
    this.isAgency = data.isAgency || false;
    this.isErc = data.isErc || false;
    this.isSub = data.isSub || false;
    this.core.permission.set(data.permissions);
    this.core.setting.set(data.settings);
    this.core.feature.set(data.feature);
  }

  logIn() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      api.account
        .login(self.model)
        .then(self.model)
        .then((data) => {
          self.model.office = data.office;
          self.user = data.user;
          const response = {
            office: data.change.office || false,
            password: data.change.password || false,
            message: data.message || null,
          };
          if (data.office && data.password) {
            self.loading = false;
            resolve(response);
          } else {
            self.model.password = '';
            self.model.repassword = '';
            self.model.newpassword = '';
            self.model.email = '';
            self
              .init()
              .then(() => {
                resolve(response);
              }, reject)
              .finally(() => {
                self.loading = false;
              });
          }
        }, (error) => {
          self.loading = false;
          reject(error);
        });
    });
  }

  logOut() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      api.account
        .logout()
        .then(() => {
          self
            .init()
            .finally(() => {
              self.loading = false;
              resolve(self);
            });
        }, (error) => {
          self.loading = false;
          reject(error);
        });
    });
  }

  logOffice() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      api.account
        .office(self.model)
        .then(() => {
          self
            .init()
            .then(() => {
              resolve(self);
            }, reject)
            .finally(() => {
              self.loading = false;
            });
        }, (error) => {
          self.loading = false;
          reject(error);
        });
    });
  }
}
